import { QRCodeSVG } from 'qrcode.react';

type QrPatternProps = {
  value: string;
  size?: number;
  className?: string;
};

/**
 * 真实可扫描的二维码。
 * value 为当前编码对应的溯源地址，手机扫码后可直接打开站内溯源页并回填该编码。
 */
export default function QrPattern({ value, size = 200, className = '' }: QrPatternProps) {
  return (
    <QRCodeSVG
      value={value || 'https://ltmzqm.amazingsite.co'}
      size={size}
      level="L"
      marginSize={3}
      bgColor="#ffffff"
      fgColor="#000000"
      className={className}
    />
  );
}